import { Injectable, signal } from '@angular/core';
import { AppService } from 'src/app/app.service';
import { ApplicationInsightsService } from 'src/app/application-insights.service';

@Injectable({
  providedIn: 'root',
})
export class ManageTeamService {
  private _teamInfoLoaded = signal<boolean>(false);
  private _triggerGridRefresh = signal<boolean>(false);
  private _userDetailsLoaded = signal<boolean>(false);

  constructor(
    private _appService: AppService,
    private _appInsightsService: ApplicationInsightsService,
  ) {}

  get teamInfoLoaded() {
    return this._teamInfoLoaded;
  }

  get triggerGridRefresh() {
    return this._triggerGridRefresh;
  }

  get userDetailsLoaded() {
    return this._userDetailsLoaded;
  }

  rebindGrid(teamLeaderEdited: boolean) {
    //Load team information
    this._appService.initializeTeam().subscribe(
      () => {
        this._teamInfoLoaded.set(true);
        this._triggerGridRefresh.set(true);
      },
      (err) => this._appInsightsService.logException(err),
    );

    // Reload userDetails if we edited the team leader
    if (teamLeaderEdited) {
      this._appService.getUserDetails(true).subscribe(
        () => this._userDetailsLoaded.set(true),
        (err) => {
          this._appInsightsService.logException(err);
          this._userDetailsLoaded.set(true);
        },
      );
    }
  }
}
